import { gsap, ScrollTrigger } from 'gsap/all';
import itsMobile from '../util/is-mobile';
import { ScrollSmoother } from '../vendor/gsap/ScrollSmoother';
import smoov from '../util/smooth-scroll';
import '../util/form-label';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

smoov();

if ($('#image-anim').length > 0) {
    gsap.set('#image-anim', {
        opacity: 0,
        x: -175,
        scale: 0.9,
    });

    const imageTl = gsap.timeline({
        scrollTrigger: {
            trigger: '.purpose-panel-block',
            scrub: true,
            start: 'top 80%',
            end: 'bottom bottom',
        },
    });

    imageTl.to('#image-anim', {
        x: 0,
        opacity: 1,
        scale: 1,
    });
}

// Work Life balance

if ($('.balance-panel-block').length > 0) {
    const photo = $('#circle_photo');

    gsap.set(photo, {
        opacity: 0,
        y: -150,
    });

    const balanceTl = gsap.timeline({

        scrollTrigger: {
            trigger: '.balance-panel-block .headline-copy',
            start: 'top bottom',
            end: '+=500',
        },

    });

    balanceTl.to(photo, {
        opacity: 1,
        y: 0,
    });
}

if ($('.turbo-line').length > 0) {
    // Intro text custom animation
    const line = $('.turbo-line');

    gsap.set(line, {
        scaleX: 0,
    });

    // Featured work intro row
    gsap.to('.js-turbo-line-wrap .turbo-line', {
        scaleX: 1,
        ease: 'linear',
        scrollTrigger: {
            trigger: '.about-quoteblock',
            start: 'top 80%',
            end: 'top 45%',
            scrub: true,
        },
    });
}

const scrollWrapper = $('.scrolly-filmstrip .scroll-wrapper');

function marqueeScroll() {
    if (itsMobile()) {
        gsap.set(scrollWrapper, { x: '5vw' });
        const marqueeTween = gsap.timeline({
            scrollTrigger: {
                trigger: '.marquee-horizontal-scroll-panel',
                scrub: true,
                start: 'top bottom',
                end: 'bottom top',
            },
        });

        marqueeTween.to(scrollWrapper, {
            x: '-=105vw',
        });
    } else {
        gsap.set(scrollWrapper, { x: '-5vw' });
        const marqueeTween = gsap.timeline({
            scrollTrigger: {
                trigger: '.marquee-horizontal-scroll-panel',
                scrub: true,
                start: 'top bottom',
                end: 'bottom top',
            },
        });

        marqueeTween.to(scrollWrapper, {
            x: '-=25vw',
        });
    }
}

if ($(scrollWrapper).length) {
    marqueeScroll();
}
